import css from 'styled-jsx/css';
import { colors, fontSizes } from '../../../../themes';

export default css`
  .item {
    align-items: center;
    color: ${colors.blue};
    display: flex;
    font-size: ${fontSizes.mediumSmall};
    padding: 7.5px 0;
  }

  .circle {
    align-items: center;
    background-color: ${colors.white};
    border-radius: 30px;
    border: solid 1.5px #bdbdbd;
    display: flex;
    height: 19.5px;
    justify-content: center;
    margin-right: 7.5px;
    width: 19.5px;
  }

  .circle.selected {
    border: solid 1.5px ${colors.blue};
  }

  .circle-fill {
    background-color: ${colors.blue};
    border-radius: 30px;
    display: block;
    height: 13.5px;
    width: 13.5px;
  }

  a {
    border-bottom: 1px solid #e1e2e6;
    display: block;
    text-decoration: none;
    width: 100%;
  }

  a:last-child {
    border-bottom: none;
  }
`;



// WEBPACK FOOTER //
// ./app/common/Lists/DisambiguationList/item/styles.js